import React from 'react';

interface PixFormProps {
  price?: number;
}

const PixForm: React.FC<PixFormProps> = ({
  price,
}) => {
  return (
    <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
      <div className="p-4 text-sm rounded-lg bg-gray-200 border-gray-600 border">
        <span className="font-semibold text-gray-600 dark:text-gray-1000">
          A confirmação de pagamento é realizada em poucos minutos.
          Utilize o aplicativo do seu banco para pagar.
        </span>
        {price && (
          <div className="mt-2">
            Valor no Pix: <div className="inline-block text-green-600 font-bold"> R$ {price.toFixed(2).replace('.', ',')}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PixForm; 